import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { FiBriefcase } from 'react-icons/fi';
import ScrollGrid from './ScrollGrid';
import FlickerText from './FlickerText';
import './Experience.css';

const experiences = [
  {
    title: 'Salesforce Developer Intern',
    company: 'SmartBridge',
    type: 'Remote',
    period: '2025',
    description: [
      'Engineered automated solutions using Salesforce Flows, significantly accelerating core business processes and reducing manual data entry errors.',
      'Structured custom objects, relationships, and advanced validation rules to maintain robust data integrity across the Salesforce ecosystem.',
    ],
    tags: ['Salesforce', 'Automation', 'Data Integrity'],
    color: '#7c6aef',
  },
];

const Experience = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: false, amount: 0.15 });

  return (
    <section className="experience" id="experience" ref={ref}>
      <ScrollGrid fadeVariant="fade-right" />
      <div className="container">
        <motion.div
          className="experience-header"
          initial={{ opacity: 0, y: 40 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0.3, y: 20 }}
          transition={{ duration: 0.6 }}
        >
          <span className="section-label">Experience</span>
          <h2 className="section-big-title">
            <FlickerText text="WHERE I'VE" isInView={isInView} /><br />
            <span className="accent"><FlickerText text="WORKED" isInView={isInView} delay={0.4} /></span><span className="muted">.</span>
          </h2>
          <p className="section-description">
            Professional experience demonstrating my expertise in
            development, automation, and problem-solving.
          </p>
        </motion.div>

        <motion.div
          className="work-section"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0.3, y: 20 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <div className="work-label">
            <FiBriefcase />
            <span>Work Experience</span>
          </div>
          {experiences.map((exp, i) => (
            <div className="work-card glass" key={i}>
              <div className="work-card-top">
                <div className="work-card-title-row">
                  <h3>{exp.title}</h3>
                  <span className="work-period" style={{ color: exp.color }}>{exp.period}</span>
                </div>
                <div className="work-meta">
                  <span className="work-company">{exp.company}</span>
                  {exp.type && <span className="work-type">{exp.type}</span>}
                </div>
              </div>
              <ul className="work-desc">
                {exp.description.map((d, j) => (
                  <li key={j}>{d}</li>
                ))}
              </ul>
              <div className="work-tags">
                {exp.tags.map((tag, j) => (
                  <span className="tag" key={j}>{tag}</span>
                ))}
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Experience;
